// Lib
import { useRef } from 'react';

export default function useUpdatedRef<T>(val: T) {
    const ref = useRef(val);
    ref.current = val;
    return ref;
}
